import { render, staticRenderFns } from "./CreateSequenceForm.vue?vue&type=template&id=bf116306&"
import script from "./CreateSequenceForm.vue?vue&type=script&lang=ts&"
export * from "./CreateSequenceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports